module.exports = __webpack_public_path__ + "static/img/img-card-crm-bigbike.278c2b3.png";